import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { withRouter } from 'react-router';
import styled from 'styled-components/macro';
import {
  getIsSearching,
  getIsBuildingSearchResults,
  getSearchTerm,
  getSearchResults,
  clearSearch,
} from '../../features/commerce/search';
import { SmallView } from '../../components/commerce/Item/list-views';
import { Item } from '../../containers/commerce';
import { Col, Row } from '../../components/grid';
import { Paragraph, Bold } from '../../components/typography';
import SearchCategory from './SearchCategory';
import HenterRute from '../../routes/HenterRute';

const HeadlineContainer = styled.div`
font-size: 22px;
font-weight: bold;
border: 2px solid #D8D8DA;
padding: 15px;
background: ${({ theme }) => theme.colors.colorBlueHighlight};
background: -moz-linear-gradient(left, ${({ theme }) => theme.colors.colorBlueHighlight} 0%, ${({ theme }) => theme.colors.colorGreyLight} 100%);
background: -webkit-linear-gradient(left, ${({ theme }) => theme.colors.colorBlueHighlight} 0%,${({ theme }) => theme.colors.colorGreyLight} 100%);
background: linear-gradient(to right, ${({ theme }) => theme.colors.colorBlueHighlight} 0%,${({ theme }) => theme.colors.colorGreyLight} 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${({ theme }) => theme.colors.colorBlueHighlight}', endColorstr='${({ theme }) => theme.colors.colorGreyLight}',GradientType=1 );
&:hover {
  cursor: pointer;
}
`;

class SearchPage extends React.Component {
  componentWillMount() {
    const { isSearching, history } = this.props;
    if (!isSearching) {
      history.push('/bestil');
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      isSearching,
      history,
    } = nextProps;
    if (!isSearching) {
      history.goBack();
    }
  }

  componentWillUnmount() {
    const { isSearching, clearSearch } = this.props;
    if (isSearching) {
      clearSearch();
    }
  }

  render() {
    const {
      isBuildingSearchResults,
      term,
      results,
    } = this.props;
    const {
      amount,
      categories,
      itemsInCategories,
      uncategorized,
      expiredItems,
    } = results;
    return (
      <React.Fragment>
        <Row>
          <Col xs={12}>
            <Paragraph>
              Viser {amount} resultater for søgningen: <Bold>{term}</Bold>
            </Paragraph>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {categories.map(
              cat => (
                <SearchCategory category={cat} key={cat}>
                  {itemsInCategories[cat].map(
                    varenr => (
                      <Item varenr={varenr} display={SmallView} allowExpiredKeepDisplay useSearchDisplay key={varenr} allowNotInState />
                    ),
                  )}
                </SearchCategory>
              ),
            )}
            {expiredItems.length > 0 && (
              <Row>
                <Col xs={12}>
                  <HeadlineContainer>Udgåede varer</HeadlineContainer>
                  {expiredItems.map(
                    varenr => (
                      <Item varenr={varenr} display={SmallView} allowExpiredKeepDisplay useSearchDisplay key={varenr} allowNotInState />
                    ),
                  )}
                </Col>
              </Row>
            )}
            {uncategorized.map(
              uncats => uncats.map(
                varenr => (
                  <Item varenr={varenr} display={SmallView} allowExpiredKeepDisplay useSearchDisplay key={varenr} allowNotInState />
                ),
              ),
            )}
          </Col>
        </Row>
        {isBuildingSearchResults && (
          <Row>
            <Col xs={12}>
              <HenterRute />
            </Col>
          </Row>
        )}
      </React.Fragment>
    );
  }
}
const selector = createSelector(
  getIsSearching,
  getIsBuildingSearchResults,
  getSearchTerm,
  getSearchResults,
  (isSearching, isBuildingSearchResults, term, results) => ({
    isSearching,
    isBuildingSearchResults,
    term,
    results,
  }),
);

export default withRouter(connect(
  selector,
  {
    clearSearch,
  },
)(SearchPage));
